export default __webpack_public_path__ + "media/art.ece1e5e3.jpg";